"use client";

import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { sans as zoram, fontSize20, lineHeightTight, fontWeightBold } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
export const internalUseOnlyPriority3 = css(["margin:0;font-family:", ";font-weight:", ";font-size:", ";line-height:", ";"], zoram, fontWeightBold, fontSize20, lineHeightTight);
const H3Styled = styled.h3.withConfig({
  componentId: "sc-yb83rz-0"
})(["", ";"], internalUseOnlyPriority3);
const H3 = _ref => {
  let {
    children,
    renderAs,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(H3Styled, {
    as: renderAs,
    ...props,
    children: children
  });
};
export default H3;
H3.propTypes = {
  /** Content inside heading */
  children: PropTypes.node.isRequired,
  /** The HTML tag string (e.g., `"div"`) or React component to render as. */
  renderAs: PropTypes.elementType
};